export default __webpack_public_path__ + "static/media/slide_ico_off.c6409cc8.svg";